<template>
    <TemplateNews page="award-record" />
</template>
